// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_home__m\\+Y9x {
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: clamp(2rem, 4vw, 4rem);
  width: 100%;
  max-width: 128rem;
  margin: 0 auto;
  padding: 2rem;
}

.Home_feed__07Vr0 {
  display: flex;
  flex: 1 1 60rem;
  min-width: 0;
  max-width: 68rem;
  flex-direction: column;
  align-items: stretch;
  gap: 3rem;
}

.Home_feedContainer__Yo6nE {
  box-sizing: border-box;
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.2rem;
  width: 100%;
  padding: clamp(1.6rem, 3vw, 3rem);
  border-radius: 10px;
  box-shadow: 1px 1px 3px var(--text-secondary);
}

.Home_profilePostedBy__LSJuJ,
.Home_accountDetails__M\\+XAb {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 1rem;
}

.Home_profilePostedBy__LSJuJ { font-size: 1.2rem; width: 100%; }
.Home_profilePostedBy__LSJuJ h3,
.Home_accountDetails__M\\+XAb p { overflow-wrap: anywhere; }

.Home_profilePostedByImage__ZCHaS,
.Home_accountImage__m6knF {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  overflow: hidden;
  border-radius: 50%;
}

.Home_postImageContainer__PewyT {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 5;
  overflow: hidden;
  background: var(--secondary_background, #f5f5f5);
}

.Home_profilePostedByImage__ZCHaS img,
.Home_accountImage__m6knF img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.Home_postImageContainer__PewyT img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.Home_likeAndCommentIcons__U\\+tGy {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 3.4rem;
}

.Home_likeCounts__bQwNo { font-size: 2rem; font-weight: 800; cursor: pointer; }
.Home_captions__pyjqP { max-width: 100%; font-size: 1.4rem; overflow-wrap: anywhere; white-space: pre-wrap; }
.Home_comments__blXgO { width: 100%; }

.Home_addCommentContainer__9Gb6X {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(9rem, auto);
  align-items: start;
  gap: 1rem;
  width: 100%;
}

.Home_addCommentContainer__9Gb6X label { min-width: 0; width: 100%; }
.Home_addCommentContainer__9Gb6X input { box-sizing: border-box; min-width: 0; width: 100%; }
.Home_addCommentContainer__9Gb6X button { width: 100%; min-height: 44px; }

.Home_sugesstionToFollow__YWSUb {
  box-sizing: border-box;
  display: flex;
  width: min(32%, 36rem);
  min-width: 28rem;
  margin-top: 2rem;
  padding: 2rem;
  flex-direction: column;
  align-items: stretch;
  gap: 3rem;
  border-radius: 10px;
  box-shadow: 1px 1px 3px var(--text-secondary);
  font-size: 2rem;
}

.Home_suggestionTextLink__2KfdN,
.Home_suggestedAccount__L0Q2X { display: flex; min-width: 0; align-items: center; justify-content: space-between; gap: 1rem; }
.Home_suggestionTextLink__2KfdN { padding-bottom: 2rem; border-bottom: 1px solid var(--text-secondary); }
.Home_suggestionTextLink__2KfdN button,
.Home_suggestedAccount__L0Q2X button { width: auto; min-width: 8rem; }
.Home_unfollow__D3DTA { color: var(--button-link-color) !important; background-color: var(--primary-backgroud) !important; border: 2px solid var(--button-link-color); }
.Home_accountDetails__M\\+XAb p { font-size: 1.6rem; }
.Home_noPost__GjSOI { grid-column: 1 / -1; width: 100%; font-size: clamp(2rem, 5vw, 4rem); text-align: center; overflow-wrap: anywhere; }
.Home_liked__pIh1j,
.Home_heartIcon__oSPbM.Home_liked__pIh1j { color: var(--heart-icon); }

.Home_heartIcon__oSPbM {
  position: absolute;
  display: inline-block;
  font-size: 6rem;
  cursor: pointer;
  transition: transform 0.3s ease-out, color 0.3s ease-out;
}

.Home_heartIcon__oSPbM.Home_animate__zPv9g { top: 50%; right: 50%; z-index: 2; color: var(--heart-icon); animation: Home_heartPulse__B0RjV 0.6s ease-in-out; }
.Home_iconAction__YHq0j { display:grid; width:4.4rem; min-height:4.4rem; padding:0; place-items:center; background:transparent; color:var(--heart-icon-default); box-shadow:none; font-size:2.4rem; }
.Home_iconAction__YHq0j:hover { background:var(--surface-secondary); }
.Home_error-message__RVxHv { margin-top: 5px; font-size: 12px; }

@keyframes Home_heartPulse__B0RjV {
  0%, 100% { transform: scale(1); opacity: 0.2; }
  50% { transform: scale(1.3); opacity: 1; }
}

@media (max-width: 1024px) {
  .Home_home__m\\+Y9x { padding: 1.5rem; }
  .Home_feed__07Vr0 { max-width: 72rem; }
  .Home_sugesstionToFollow__YWSUb { display: none; }
}

@media (max-width: 768px) {
  .Home_home__m\\+Y9x { margin: 0; padding: 0 0 calc(var(--mobile-navigation-height, 6rem) + env(safe-area-inset-bottom, 0px)); }
  .Home_feed__07Vr0 { flex-basis: 100%; width: 100%; max-width: none; gap: 1.2rem; }
  .Home_feedContainer__Yo6nE { padding: 1.2rem 1rem; border-radius: 0; box-shadow: none; }
  .Home_postImageContainer__PewyT { width: calc(100% + 2rem); margin-inline: -1rem; }
}

@media (max-width: 375px) {
  .Home_feedContainer__Yo6nE { padding-inline: .8rem; }
  .Home_postImageContainer__PewyT { width: calc(100% + 1.6rem); margin-inline: -.8rem; }
  .Home_addCommentContainer__9Gb6X { grid-template-columns: minmax(0, 1fr) auto; gap: .6rem; }
  .Home_addCommentContainer__9Gb6X button { min-width: 8.4rem; padding-inline: .6rem; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/Home.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA,+BAAmB,iBAAiB,EAAE,WAAW,EAAE;AACnD;iCACoB,uBAAuB,EAAE;;AAE7C;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA,0BAAc,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAClE,wBAAY,eAAe,EAAE,iBAAiB,EAAE,uBAAuB,EAAE,qBAAqB,EAAE;AAChG,wBAAY,WAAW,EAAE;;AAEzB;EACE,aAAa;EACb,wDAAwD;EACxD,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA,yCAA6B,YAAY,EAAE,WAAW,EAAE;AACxD,yCAA6B,sBAAsB,EAAE,YAAY,EAAE,WAAW,EAAE;AAChF,0CAA8B,WAAW,EAAE,gBAAgB,EAAE;;AAE7D;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,mBAAmB;EACnB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;gCACoB,aAAa,EAAE,YAAY,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE;AACjH,kCAAsB,oBAAoB,EAAE,8CAA8C,EAAE;AAC5F;uCAC2B,WAAW,EAAE,eAAe,EAAE;AACzD,wBAAY,0CAA0C,EAAE,qDAAqD,EAAE,0CAA0C,EAAE;AAC3J,iCAAoB,iBAAiB,EAAE;AACvC,sBAAU,mBAAmB,EAAE,WAAW,EAAE,iCAAiC,EAAE,kBAAkB,EAAE,uBAAuB,EAAE;AAC5H;2CACmB,wBAAwB,EAAE;;AAE7C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,wDAAwD;AAC1D;;AAEA,6CAAqB,QAAQ,EAAE,UAAU,EAAE,UAAU,EAAE,wBAAwB,EAAE,kDAAsC,EAAE;AACzH,0BAAc,YAAY,EAAE,YAAY,EAAE,iBAAiB,EAAE,SAAS,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,+BAA+B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACxL,gCAAoB,mCAAmC,EAAE;AACzD,6BAAiB,eAAe,EAAE,eAAe,EAAE;;AAEnD;EACE,WAAW,mBAAmB,EAAE,YAAY,EAAE;EAC9C,MAAM,qBAAqB,EAAE,UAAU,EAAE;AAC3C;;AAEA;EACE,qBAAQ,eAAe,EAAE;EACzB,oBAAQ,gBAAgB,EAAE;EAC1B,kCAAsB,aAAa,EAAE;AACvC;;AAEA;EACE,qBAAQ,SAAS,EAAE,2FAA2F,EAAE;EAChH,oBAAQ,gBAAgB,EAAE,WAAW,EAAE,eAAe,EAAE,WAAW,EAAE;EACrE,6BAAiB,oBAAoB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;EAC3E,kCAAsB,wBAAwB,EAAE,oBAAoB,EAAE;AACxE;;AAEA;EACE,6BAAiB,qBAAqB,EAAE;EACxC,kCAAsB,0BAA0B,EAAE,qBAAqB,EAAE;EACzE,mCAAuB,0CAA0C,EAAE,UAAU,EAAE;EAC/E,0CAA8B,iBAAiB,EAAE,qBAAqB,EAAE;AAC1E","sourcesContent":[".home {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  gap: clamp(2rem, 4vw, 4rem);\r\n  width: 100%;\r\n  max-width: 128rem;\r\n  margin: 0 auto;\r\n  padding: 2rem;\r\n}\r\n\r\n.feed {\r\n  display: flex;\r\n  flex: 1 1 60rem;\r\n  min-width: 0;\r\n  max-width: 68rem;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  gap: 3rem;\r\n}\r\n\r\n.feedContainer {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  min-width: 0;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 1.2rem;\r\n  width: 100%;\r\n  padding: clamp(1.6rem, 3vw, 3rem);\r\n  border-radius: 10px;\r\n  box-shadow: 1px 1px 3px var(--text-secondary);\r\n}\r\n\r\n.profilePostedBy,\r\n.accountDetails {\r\n  display: flex;\r\n  min-width: 0;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.profilePostedBy { font-size: 1.2rem; width: 100%; }\r\n.profilePostedBy h3,\r\n.accountDetails p { overflow-wrap: anywhere; }\r\n\r\n.profilePostedByImage,\r\n.accountImage {\r\n  width: 40px;\r\n  height: 40px;\r\n  flex: 0 0 40px;\r\n  overflow: hidden;\r\n  border-radius: 50%;\r\n}\r\n\r\n.postImageContainer {\r\n  position: relative;\r\n  width: 100%;\r\n  aspect-ratio: 4 / 5;\r\n  overflow: hidden;\r\n  background: var(--secondary_background, #f5f5f5);\r\n}\r\n\r\n.profilePostedByImage img,\r\n.accountImage img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.postImageContainer img {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n.likeAndCommentIcons {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  font-size: 3.4rem;\r\n}\r\n\r\n.likeCounts { font-size: 2rem; font-weight: 800; cursor: pointer; }\r\n.captions { max-width: 100%; font-size: 1.4rem; overflow-wrap: anywhere; white-space: pre-wrap; }\r\n.comments { width: 100%; }\r\n\r\n.addCommentContainer {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr) minmax(9rem, auto);\r\n  align-items: start;\r\n  gap: 1rem;\r\n  width: 100%;\r\n}\r\n\r\n.addCommentContainer label { min-width: 0; width: 100%; }\r\n.addCommentContainer input { box-sizing: border-box; min-width: 0; width: 100%; }\r\n.addCommentContainer button { width: 100%; min-height: 44px; }\r\n\r\n.sugesstionToFollow {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  width: min(32%, 36rem);\r\n  min-width: 28rem;\r\n  margin-top: 2rem;\r\n  padding: 2rem;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  gap: 3rem;\r\n  border-radius: 10px;\r\n  box-shadow: 1px 1px 3px var(--text-secondary);\r\n  font-size: 2rem;\r\n}\r\n\r\n.suggestionTextLink,\r\n.suggestedAccount { display: flex; min-width: 0; align-items: center; justify-content: space-between; gap: 1rem; }\r\n.suggestionTextLink { padding-bottom: 2rem; border-bottom: 1px solid var(--text-secondary); }\r\n.suggestionTextLink button,\r\n.suggestedAccount button { width: auto; min-width: 8rem; }\r\n.unfollow { color: var(--button-link-color) !important; background-color: var(--primary-backgroud) !important; border: 2px solid var(--button-link-color); }\r\n.accountDetails p { font-size: 1.6rem; }\r\n.noPost { grid-column: 1 / -1; width: 100%; font-size: clamp(2rem, 5vw, 4rem); text-align: center; overflow-wrap: anywhere; }\r\n.liked,\r\n.heartIcon.liked { color: var(--heart-icon); }\r\n\r\n.heartIcon {\r\n  position: absolute;\r\n  display: inline-block;\r\n  font-size: 6rem;\r\n  cursor: pointer;\r\n  transition: transform 0.3s ease-out, color 0.3s ease-out;\r\n}\r\n\r\n.heartIcon.animate { top: 50%; right: 50%; z-index: 2; color: var(--heart-icon); animation: heartPulse 0.6s ease-in-out; }\r\n.iconAction { display:grid; width:4.4rem; min-height:4.4rem; padding:0; place-items:center; background:transparent; color:var(--heart-icon-default); box-shadow:none; font-size:2.4rem; }\r\n.iconAction:hover { background:var(--surface-secondary); }\r\n.error-message { margin-top: 5px; font-size: 12px; }\r\n\r\n@keyframes heartPulse {\r\n  0%, 100% { transform: scale(1); opacity: 0.2; }\r\n  50% { transform: scale(1.3); opacity: 1; }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .home { padding: 1.5rem; }\r\n  .feed { max-width: 72rem; }\r\n  .sugesstionToFollow { display: none; }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .home { margin: 0; padding: 0 0 calc(var(--mobile-navigation-height, 6rem) + env(safe-area-inset-bottom, 0px)); }\r\n  .feed { flex-basis: 100%; width: 100%; max-width: none; gap: 1.2rem; }\r\n  .feedContainer { padding: 1.2rem 1rem; border-radius: 0; box-shadow: none; }\r\n  .postImageContainer { width: calc(100% + 2rem); margin-inline: -1rem; }\r\n}\r\n\r\n@media (max-width: 375px) {\r\n  .feedContainer { padding-inline: .8rem; }\r\n  .postImageContainer { width: calc(100% + 1.6rem); margin-inline: -.8rem; }\r\n  .addCommentContainer { grid-template-columns: minmax(0, 1fr) auto; gap: .6rem; }\r\n  .addCommentContainer button { min-width: 8.4rem; padding-inline: .6rem; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home": `Home_home__m+Y9x`,
	"feed": `Home_feed__07Vr0`,
	"feedContainer": `Home_feedContainer__Yo6nE`,
	"profilePostedBy": `Home_profilePostedBy__LSJuJ`,
	"accountDetails": `Home_accountDetails__M+XAb`,
	"profilePostedByImage": `Home_profilePostedByImage__ZCHaS`,
	"accountImage": `Home_accountImage__m6knF`,
	"postImageContainer": `Home_postImageContainer__PewyT`,
	"likeAndCommentIcons": `Home_likeAndCommentIcons__U+tGy`,
	"likeCounts": `Home_likeCounts__bQwNo`,
	"captions": `Home_captions__pyjqP`,
	"comments": `Home_comments__blXgO`,
	"addCommentContainer": `Home_addCommentContainer__9Gb6X`,
	"sugesstionToFollow": `Home_sugesstionToFollow__YWSUb`,
	"suggestionTextLink": `Home_suggestionTextLink__2KfdN`,
	"suggestedAccount": `Home_suggestedAccount__L0Q2X`,
	"unfollow": `Home_unfollow__D3DTA`,
	"noPost": `Home_noPost__GjSOI`,
	"liked": `Home_liked__pIh1j`,
	"heartIcon": `Home_heartIcon__oSPbM`,
	"animate": `Home_animate__zPv9g`,
	"heartPulse": `Home_heartPulse__B0RjV`,
	"iconAction": `Home_iconAction__YHq0j`,
	"error-message": `Home_error-message__RVxHv`
};
export default ___CSS_LOADER_EXPORT___;
